export const routes = {
  login: "/login",
  authHandoff: "/auth/handoff",
  tenantDashboard: "/tenant/billing",
  tenantInvoices: "/tenant/billing/invoices",
  tenantInvoiceDetail: "/tenant/billing/invoices/:id",
  tenantInvoiceTemplates: "/tenant/billing/invoice-templates",
  tenantQuotes: "/tenant/billing/quotes",
  tenantCreditNotes: "/tenant/billing/credit-notes",
  tenantCustomers: "/tenant/billing/customers",
  tenantPayments: "/tenant/billing/payments",
  tenantSettings: "/tenant/billing/settings",
} as const;
